import React from "react";

import WorkflowStates from "./WorkflowStates";
import WorkflowMethods from "./WorkflowMethods";
import WorkflowTransitions from "./WorkflowTransitions";
import WorkflowEvents from "./WorkflowEvents";

export default class WorkflowConstructor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      state: {},
      action: {},
      transition: {},
    };
  }
  onStateChanged = (state) => {
    this.setState({ state });
  };
  onActionChanged = (action) => {
    this.setState({ action });
  };
  onTransitionChanged = (transition) => {
    this.setState({ transition });
  };

  render() {
    return (
      <>
        <h6 className="text-muted">Состояния</h6>
        <WorkflowStates
          onChange={this.onStateChanged}
          classId={this.props.classId}
        />
        <div className="my-10 border-top"></div>
        <h6 className="text-muted">Операции</h6>
        <WorkflowMethods
          onChange={this.onActionChanged}
          classId={this.props.classId}
          stateId={this.state.state.id}
          stateItem={this.state.state}
          key={this.state.state.id}
        />
        <div className="my-10 border-top"></div>
        <h6 className="text-muted">Переход в новое состояние</h6>
        <WorkflowTransitions
          onChange={this.onTransitionChanged}
          classId={this.props.classId}
          stateId={this.state.state.id}
          stateItem={this.state.state}
          actionId={this.state.action.id}
          actionItem={this.state.action}
          key={`transitions${this.state.state.id}${this.state.action.id}`}
        />
        <div className="my-10 border-top"></div>
        <h6 className="text-muted">События</h6>
        <WorkflowEvents
          onChange={() => {}}
          classId={this.props.classId}
          stateId={this.state.state.id}
          stateItem={this.state.state}
          actionId={this.state.action.id}
          actionItem={this.state.action}
          key={`events${this.state.state.id}${this.state.action.id}`}
        />
      </>
    );
  }
}
